import React, { useRef, useEffect } from "react";
import { useInView } from "react-spring";

export const Video = ({ fullWebm, fullMp, poster, classes, portrait }) => {
  const [containerRef, isInView] = useInView({});
  const videoRef = useRef(null);
  const logoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current)
      isInView ? videoRef.current.play() : videoRef.current.pause();
  }, [isInView]);

  useEffect(() => {
    if (document.readyState !== "loading") {
      setTimeout(() => {
        if (logoRef.current) logoRef.current.classList.add("reveal");
      }, 1000);
    }

    return () => clearTimeout();
  }, []);

  return (
    <div className={classes} id="atf" ref={containerRef}>
      <video
        poster={poster}
        ref={videoRef}
        autoPlay
        loop
        preload="none"
        muted
        playsInline
        style={portrait ? { height: "100%" } : { height: "unset" }}
      >
        <source src={fullMp} type="video/mp4" />
        <source src={fullWebm} type="video/webm" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};
